var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFireEmoji(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3332 12.6667C23.3332 11.292 23.0885 9.97402 22.6398 8.75468C22.3332 12.3473 20.4178 14.1927 18.4165 13.3333C16.5418 12.528 17.8052 9.38868 17.8985 7.89068C18.0558 5.35135 17.8905 2.44468 13.2778 0.0280151C15.1945 3.69468 13.4998 5.97268 11.7225 6.11135C9.7505 6.26535 7.9445 4.41668 8.61117 1.41668C6.4525 3.00735 6.38984 5.68468 7.05584 7.41668C7.7505 9.22202 7.02784 10.722 5.33384 10.8887C3.4405 11.0753 2.3885 8.86135 3.3585 5.33335C1.67984 7.31002 0.666504 9.87002 0.666504 12.6667C0.666504 18.926 5.7405 24 11.9998 24C18.2592 24 23.3332 18.926 23.3332 12.6667Z",
    fill: "#F4900C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9293 15.9993C19.028 18.0553 17.222 18.8613 16.25 18.472C14.846 17.91 15.2227 16.9446 14.8613 14.9446C14.5 12.9446 13.1113 11.556 11.056 10.9446C12.556 15.1666 10.2247 16.7226 9.00267 17.0006C7.75467 17.2846 6.50067 17 6.35733 14.3293C4.90133 15.7786 4 17.784 4 20C4 20.2453 4.01533 20.4866 4.03667 20.7266C6.08333 22.7493 8.89467 24 12 24C15.1053 24 17.9167 22.7493 19.9633 20.7266C19.9847 20.4866 20 20.2453 20 20C20 18.542 19.6107 17.176 18.9293 15.9993Z",
    fill: "#FFCC4D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFireEmoji);
export default __webpack_public_path__ + "static/media/fire-emoji.bf9fd33f93ca30891bbf6e4c0858ef6b.svg";
export { ForwardRef as ReactComponent };